import request from '@/utils/httpClient'
import { RepairUpdateParams } from '@/types/domain/repair'

// 更新维修记录
export function updateRepair(id: number, data?: RepairUpdateParams) {
  return request({
    url: `repair/${id}`,
    method: 'put',
    data
  })
}

// 业务联系人列表
export function businessConcatsList(id: number) {
  return request({
    url: `business/${id}/actions/contacts`,
    method: 'get'
  })
}
// 业务联系人列表
export function businessEngineersList(id: number) {
  return request({
    url: `business/${id}/actions/engineers`,
    method: 'get'
  })
}
